import { TSuggestElement } from '../../../../types/factFinder'

export enum EActions {
  LOAD_SUGGESTIONS_START = 'LOAD_SUGGESTIONS_START',
  LOAD_SUGGESTIONS_END = 'LOAD_SUGGESTIONS_END',
  CLEAR_SUGGESTIONS = 'CLEAR_SUGGESTIONS',
  SELECT_SUGGESTION = 'SELECT_SUGGESTION',
  SET_SEARCH_TERM = 'SET_SEARCH_TERM',
}

export type TInitialState = {
  searchTerm: string
  suggestions: TSuggestElement[]
  selectedSuggestion: number
  isLoading: boolean
}

export const initialState: TInitialState = {
  searchTerm: '',
  suggestions: [],
  selectedSuggestion: -1,
  isLoading: false,
}

const reducer = (state: TInitialState, action: { type: EActions; payload? }): TInitialState => {
  switch (action.type) {
    case EActions.LOAD_SUGGESTIONS_START:
      return { ...state, isLoading: true }
    case EActions.LOAD_SUGGESTIONS_END:
      return { ...state, isLoading: false, suggestions: action.payload }
    case EActions.CLEAR_SUGGESTIONS:
      return {
        ...state,
        suggestions: [],
        selectedSuggestion: initialState.selectedSuggestion,
      }
    case EActions.SELECT_SUGGESTION:
      return { ...state, selectedSuggestion: action.payload }
    case EActions.SET_SEARCH_TERM:
      return { ...state, searchTerm: action.payload }
    default:
      return state
  }
}

export default reducer
